import { BUSINESS_ROLE_GROUPS, ROLES } from '@/components/security/AppRoles';

export const INTEGRATION_REQUESTS_PATH = '/business/commerce/integration-requests';
export const INTEGRATION_REQUESTS_TITLE = 'Solicitudes de integración';
export const IT_TEAM_SECTION_TITLE = 'Equipo IT';
export const INTEGRATION_API_TITLE = 'Integración API';

export const INTEGRATION_REQUEST_ROLES = [
  ...BUSINESS_ROLE_GROUPS.management,
  ROLES.BUSINESS.it,
].filter(Boolean);

export const INTEGRATION_IT_ROLES = [ROLES.BUSINESS.it].filter(Boolean);

export const apiErrorMessage = (error: unknown, fallback: string): string => {
  const candidate = error as { data?: { message?: string } };
  return candidate?.data?.message || fallback;
};
